export default __webpack_public_path__ + "static/media/bamba3.4834a70b.md";